import { FC } from 'react';
// Redux
import { useAppSelector } from 'hooks/useStore';
import { selectQuiz } from 'store/quiz/quizSelectors';
import IQuiz from 'models/Quiz';

type Props = {
  progress: number;
}

const VideoTimeline:FC<Props> = ({ progress }) => {
  const quiz:IQuiz = useAppSelector(selectQuiz);

  return (
    <div
      className="absolute w-11/12 bottom-0 left-0 bg-gray-200 border-4 border-gray-200 h-4 rounded-lg mb-2 ml-4 z-10"
    >
      <div className="absolute top-0 left-0 w-full h-2 opacity-25 rounded-lg z-0" style={{ backgroundColor: quiz.theme.progressBarColor }}></div>
      <div className="absolute top-0 left-0 h-2 rounded-lg z-10" style={{ width: `${progress}%`, backgroundColor: quiz.theme.progressBarColor }}></div>
    </div>
  )
}

export default VideoTimeline;
